import { render, staticRenderFns } from "./DownlineOTPNuera.vue?vue&type=template&id=057c3c0e&scoped=true&"
import script from "./DownlineOTPNuera.vue?vue&type=script&lang=js&"
export * from "./DownlineOTPNuera.vue?vue&type=script&lang=js&"
import style0 from "./DownlineOTPNuera.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DownlineOTPNuera.vue?vue&type=style&index=1&id=057c3c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057c3c0e",
  null
  
)

export default component.exports